package org.dronda.app.web.repository

import com.github.michaelbull.result.Result
import org.dronda.app.web.client.LocationFriendResponse
import org.dronda.app.web.client.LocationSharingClient
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

class LocationSharingRepository(
    private val locationSharingClient: LocationSharingClient
) {

    suspend fun loadFriends(): Result<List<LocationFriendResponse>, Unit> {
        return locationSharingClient.fetchLocationSharingFriends()
    }

    @OptIn(ExperimentalUuidApi::class)
    suspend fun deleteLocationSharingFriend(userId: Uuid) {
        locationSharingClient.deleteLocationSharingFriend(userId)
    }
}